// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  capchaClientId: '6LdJb90ZAAAAAO0W8pM0Ldco6o3nMtv8pURce7jx',
  userApi : 'https://dev-idb.unitech.taffinc.com',
  claimsApi: 'https://dev-idb.unitech.taffinc.com',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
